/** @jsxImportSource @emotion/react */

import { CustomCellEditorProps } from "ag-grid-react";
import { MultiStringEditor } from "components/ToolEditor/components/MultiStringEditor";
import { ToolPathParamDetailRowDatum } from "./DetailRendererToolPathParam";
import { memo } from "react";
import { CANCEL_CELL_EDIT_VALUE } from "components/ToolEditor/constants";

export type CellEditorTagsProps = Pick<
  CustomCellEditorProps<ToolPathParamDetailRowDatum>,
  "onValueChange" | "stopEditing" | "data"
>;

/**
 * Cell editor for file formats
 */
export const CellEditorTags = memo(function CellEditorTags({
  data,
  onValueChange: _onValueChange,
  stopEditing,
}: CellEditorTagsProps) {
  const onClose = (cancel?: boolean) => {
    if (cancel) {
      _onValueChange(CANCEL_CELL_EDIT_VALUE);
    }
    stopEditing(cancel);
  };

  const onValueChange = (newValue: string[]) => {
    const nonEmptyValues = newValue.filter((val) => val !== "");
    if (nonEmptyValues.length === 0) {
      return _onValueChange(undefined);
    }
    return _onValueChange(nonEmptyValues);
  };

  return (
    <MultiStringEditor
      initialValue={data.tags ?? []}
      onClose={onClose}
      onValueChange={onValueChange}
    />
  );
});
